import Api from './Api'
import axios from 'axios'

let cancelDataRequest = null

class CompaniesDataService {
    getAll = async params => {
        if (cancelDataRequest) {
            cancelDataRequest()
        }
        const CancelToken = axios.CancelToken
        const response = await Api().get('companies/all', {
            params: params,
            cancelToken: new CancelToken(c => {
                cancelDataRequest = c
            }),
        })
        cancelDataRequest = null
        return response
    }
    get = async (companyId, params) => {
        if (cancelDataRequest) {
            cancelDataRequest()
        }
        const CancelToken = axios.CancelToken
        const response = await Api().get(`companies/${companyId}`, {
            params: params,
            cancelToken: new CancelToken(c => {
                cancelDataRequest = c
            }),
        })
        cancelDataRequest = null
        return response
    }

    getAllStationLocationLongAliases = async params => {
        if (cancelDataRequest) {
            cancelDataRequest()
        }
        const CancelToken = axios.CancelToken
        const response = await Api().get('station-location/long-aliases', {
            params: params,
            cancelToken: new CancelToken(c => {
                cancelDataRequest = c
            }),
        })
        cancelDataRequest = null
        return response
    }

    updateCompanyHasPredictionRights = async (companyId, data) => {
        return await Api().put(`companies/${companyId}/toggle-has-prediction-rights`, data)
    }

    editCompanyField = async (companyId, data) => {
        return await Api().put(`companies/${companyId}/edit-field`, data)
    }

    createCompany = async (companyId, data) => {
        return await Api().post(`companies/${companyId}`, data)
    }

    editCompany = async (companyId, data) => {
        return await Api().put(`companies/${companyId}`, data)
    }

    getStationLocations = async (companyId) => {
        return await Api().get(`companies/${companyId}/station-locations`)
    }

    getAllStations = async (companyId) => {
        return await Api().get(`companies/${companyId}/add-station`)
    }

    addStation = async (companyId, params) => {
        return await Api().post(`companies/${companyId}/add-station`, params)
    }

}

export default new CompaniesDataService()
